import React, { Component } from 'react';
import {connect} from 'react-redux';
import { withRouter } from 'react-router';
import {redirectToDps} from '../../../redux/actions/globalActions'

class RedirectToDPS extends Component {

    UNSAFE_componentWillMount() {
       if(this.props.user.user_profile && !this.props.user.user_ctoken) {
            this.props.redirectToDps(this.props.clientPath, this.props.user.user_profile.email,this.props.user.user_profile.user_security, this.props.user.user_profile.dps_uid);
       }

       if(this.props.user.user_ctoken) {
            window.location.href = "http://dps.acceptage.nl/login?custom_token="+this.props.user.user_ctoken;
       }
    }

    componentDidUpdate(prevProps){
        if(prevProps.user.user_ctoken !== this.props.user.user_ctoken) {
            window.location.href = "http://dps.acceptage.nl/login?custom_token="+this.props.user.user_ctoken;
        }
    }

    render() {
        return (
            <div>

             </div>
        );
    }
}

function mapStateToProps(state) {
    return {
         user: state.UserReducer,
         clientPath: state.ClientPathReducer.clientPath
      }
  }

  const mapDispatchToProps = (dispatch) => {
    return {
        redirectToDps: (url, email, password, dpsUid) => dispatch(redirectToDps(url, email, password, dpsUid)),
      };
  };

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RedirectToDPS));



// WEBPACK FOOTER //
// ./src/components/Application/RedirectToDPS/index.js